<template>
    <!--用户注册-->
    <div class="register">
        <div class="header" style="font-size: 16px;">
            <img src="../../imgs/ico10.png" alt="">重置密码
        </div>
        <ul class="reg-box">
            <li class="errmsg">
                {{msg}}
            </li>
            <li>
                <label>
                    <span>邮箱</span>
                    <input  type="text" v-model="userData.email" placeholder="邮箱" >
                </label>
            </li>
            <li>
                <label>
                    <span>验证码</span>
                    <input type="text" v-model="userData.code" placeholder="验证码" style="width:250px">
                    <button @click="getCode()"  :disabled="codeFlag=='0'"
                            style="font-size: 16px;width:120px;background-color:#AE0D73;color:#FFF;border:0;height:40px;margin-left:90px;cursor:pointer">{{verifyMsg}}</button>
                </label>
            </li>
            <li>
                <label>
                    <span>新密码</span>
                    <input type="password" v-model="userData.pwd" placeholder="新密码">
                </label>
            </li>
            <li>
                <label>
                    <span>确认新密码</span>
                    <input type="password" v-model="userData.cpwd" placeholder="确认新密码">
                </label>
            </li>
        </ul>
        <div class="reg-btn-box">
            <button @click="doReg">确认</button>
        </div>
    </div>
</template>
<script>
/*
   * /api/register/add
   * firstpy   lastpy   email  pwd language
   language en
   * */

import md5 from 'md5';
export default {
    data() {
            return {
                showErrorMsg: false,
                showMsg: false,
                msg: '',
                verifyMsg: '获取验证码',
              codeFlag: '1',
                userData: {
                    email: '',
                    code: '',
                    pwd: '',
                    cpwd: '',
                    language: 'cn'
                }
            }
        },
        props: {},
        methods: {
            //去往注册页面
            getCode() {
                if (this.userData.email.trim().length === 0) {
                    this.msg = '请输入您的邮箱!';
                    this.showMsg = true;
                    return;
                }

              this.countDown();

                axios.post('/medapp/api/register/identify', {
                    email: this.userData.email,
                    type: "FIND",
//                    language:"cn",
                }).then((result) => {
                    debugger
                    if(result.data.code=="0"){
                      this.$Message.success('验证码已发送！', 6);
                      console.log(result.data.identify);
                    }else if(result.data.code=="1002"){
                      this.$Message.warning('请输入正确的邮箱!', 6);
                      console.log(result.data.code);
                    }

                });
            },
            countDown() {

              let num = 60;
              let timer = setInterval(() => {
                  num--;
                this.num = num;
                if (num === 0) {
                      clearInterval(timer);
                      this.codeFlag = '1';
                      this.verifyMsg = "获取验证码"
                } else {
                      this.codeFlag = '0';
                      this.verifyMsg = this.num + 's后重新获取'
                }
              }, 1000)
            },
            doReg() {
                let userData = this.userData;
                if (this.userData.email.trim().length === 0) {
                    this.msg = '请输入您的邮箱';
                    this.showMsg = true;
                    return;
                } else if (this.userData.code.trim().length === 0) {
                    this.msg = '请输入您的验证码';
                    this.showMsg = true;
                    return;
                } else if (this.userData.pwd.trim().length === 0) {
                    this.msg = '请输入您的密码';
                    this.showMsg = true;
                    return;
                } else if (this.userData.cpwd.trim().length === 0) {
                    this.msg = '请输入您的确认密码';
                    this.showMsg = true;
                    return;
                } else if (this.userData.cpwd != this.userData.pwd) {
                    this.msg = '请输入您的密码和确认密码必须一致';
                    this.showMsg = true;
                    return;
                }else {
                    this.showMsg = false;
                }
                axios.post('/medapp/api/register/changepwd', {
                        email: userData.email,
                        pwd: md5(userData.pwd),
                        identify: userData.code,
                    })
                    .then((result) => {
                        console.log(result.data);
                        let data = result.data;
                        //            用户修改密码成功
                        if (data.code === '0') {
                            this.$Message.success('修改密码成功', 3);
                            this.$router.push('/home/2006/detail/login_cn');
                        } else if(data.code === '1007'){
                            this.msg = '请输入正确的邮箱! ';
                            this.showMsg = true;
                        }else if(data.code === '1003'){
                            this.msg = 'invalid identify';
                            this.showMsg = true;
                        }
                    })
            },
          sendCode:function(){
                debugger
            hz.ajaxRequest("sys/sendCode?_"+$.now(),function(data){
              if(data.status){
                vm.$refs.timerbtn.start(); //启动倒计时
              }else{
                vm.$refs.timerbtn.stop(); //停止倒计时
              }
            });
          }
        },
        computed: {},
        mounted() {}
}
</script>
<style scoped>
.login {
    text-align: right;
}

.login p {
    display: inline-block;
    cursor: pointer;
}

.register {
    font-family: "Arial";
}

.reg-box .errmsg {
    color: red;
    font-size: 14px;
    margin-left: 147px;
}

.header {
    height: 89px;
    background-color: #F4F4F7;
    color: #4C4E82;
    font-size: 22px;
    line-height: 89px;
}

.header img {
    vertical-align: middle;
    margin-left: 50px;
    margin-right: 21px;
}


/*注册框开始*/

.reg-box {
    width: 905px;
    margin: 48px auto 0;
    font-size: 20px;
}

.reg-box li {
    margin: 20px 0;
}

.reg-box label span {
    display: inline-block;
    width: 200px;
    text-align: right;
    line-height: 40px;
    color: #000;
    margin-right: 20px;
    font-size: 16px;
}

.reg-box label input {
    width: 465px;
    height: 40px;
    background-color: #f3f3f6;
    border: 1px solid #141651;
    padding-left: 18px;
    box-sizing: border-box;
    font-size: 16px;
}

.reg-btn-box {
    text-align: center;
    margin-top: 84px;
}

.reg-btn-box button {
    color: #FFFFFF;
    font-size: 16px;
    border: 0;
    background-color: #141651;
    padding: 12px 63px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resetpass_cn.vue?8b78756e